<div class="kw-page">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">Cycle Count</h2>
      <span class="page-subtitle">Count on-hand {{"inventory" | tenantWords}} by {{"room" | tenantWords}} and location</span>
    </div>
  </div>

  <ng-container *ngIf="this.selectedStep == steps.SELECT_AREA">
    <div class="filters-bar" [nbSpinner]="this.isLoading">
      <kw-filter-dropdown class="filter-widget" [filterSettings]="this.dropdownSettings"
        (filterResultsChange)="setFilterResults()"></kw-filter-dropdown>
    </div>

    <div class="kw-empty-card">
      <div class="lottie-item">
        <ng-lottie [options]="lottieConfig"></ng-lottie>
      </div>
      <div class="empty-title">Select a location</div>
      <div>Pick a {{"room" | tenantWords}}, then the warehouses and locations to count.</div>
    </div>
  </ng-container>

</div>
